import { loadUIConfig } from "@digatex/digatex-ui-lib";
import { getProductLinks } from "../config/product-links";
import ProjectUIConfig from "../config/ui-config.json";

export const UI_CONFIG = ProjectUIConfig?.dummy
  ? loadUIConfig()
  : ProjectUIConfig;

const productLinks = getProductLinks(UI_CONFIG);

export const properties = {
  baseUrl: process.env.REACT_APP_BASE_URL,
  apiHost: process.env.REACT_APP_HOST,
  instance: process.env.REACT_APP_INSTANCE,
  title: process.env.REACT_APP_PROJECT_TITLE,
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL,
  previewRowsPerPage: 50,
  colors: {
    oceanBlue: "#004987",
    lightBlue: "#A2C7E2",
    yellow: "#ffda00",
    darkBlue: "#00205C",
    green: "#00783F",
    black: "#231f20",
    brightBlue: "#007fc5",
    darkRed: "#feffdb66",
  },

  ihLink: productLinks.ihLink,
  khLink: productLinks.khLink,
  analyticsLink: productLinks.analyticsLink,
  assetHubLink: productLinks.assetHubLink,
  landingUrl: productLinks.landingUrl,

  adminRoles: process.env.REACT_APP_ADMIN_ROLES || [],
  allBatches: process.env.REACT_APP_ALL_BATCHES || []
}

export const OWNER = process.env.REACT_APP_OWNER;

export const BATCH_WITH_ALL_MATERIALS = process.env.REACT_APP_BATCH_WITH_ALL_MATERIALS;
export const FINAL_TABLE_PAGE_SIZE = process.env.REACT_APP_FINAL_TABLE_PAGE_SIZE;

export const KEYCLOAK_AUTH_SERVER_URL = process.env.REACT_APP_KEYCLOAK_AUTH_SERVER_URL;
export const KEYCLOAK_CLIENT_ID = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REALM;

export const JIRA_DATA_KEY = process.env.REACT_APP_JIRA_DATA_KEY;

export const REACT_APP_UI_THEME = process.env.REACT_APP_UI_THEME;